import {Component} from '@angular/core';
import {Events, IonicPage, NavController, NavParams, ViewController} from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";

@IonicPage()
@Component({
  selector: 'page-checkin-popover',
  templateUrl: 'checkin-popover.html',
})
export class CheckinPopoverPage {

  barber: any;
  currentTeam: any;
  selectedTeam: any;
  loading: boolean;
  errors: {};

  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public events: Events,
    private http: HttpClient,
    private apiErrorHandler: ApiErrorHandlerProvider
  ) {
    this.barber = navParams.get('barber');
    this.currentTeam = navParams.get('currentTeam');
    this.selectedTeam = navParams.get('selectedTeam');
  }

  checkIn() {
    this.viewCtrl.dismiss(this.selectedTeam)
  }

  closePopover() {
    this.viewCtrl.dismiss();
  }

  currentTeamName() {
    if (this.currentTeam.branch_name === null) return this.currentTeam.name;

    return this.currentTeam.branch_name;
  }

  selectedTeamName() {
    if (this.selectedTeam.branch_name === null) return this.selectedTeam.name;

    return this.selectedTeam.branch_name;
  }

}



// WEBPACK FOOTER //
// ./src/pages/checkin-popover/checkin-popover.ts